module.exports = __webpack_public_path__ + "img/truckElectric3.02d25b84.png";